






















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import PointerMenu from "../general/PointerMenu.vue";
import CategoryTypeInput from "../general/CategoryTypeInput.vue";
import CategoryTypeSelect from "../general/CategoryTypeSelect.vue";
import HtmlEditor from "../controls/HtmlEditor.vue";
import FormImageBase64 from "../general/FormImageBase64.vue";
import LocationInput from "../general/LocationInput.vue";
import MaterialItemInput from "../general/MaterialItemInput.vue";
import ClientsClientSelect from "../clients/ClientsClientSelect.vue";
import StaffInput from "../general/StaffInput.vue";
import FormPrice from "../general/FormPrice.vue";
import CustomInputInput from "../general/CustomInputInput.vue";

import SettingsJson from "../../shared/SettingsJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import LocationJson, { defaultLocationJson } from "../../shared/LocationJson";
import UserJson, { defaultUserJson } from "../../shared/UserJson";
import MaterialItemJson, { defaultMaterialItemJson } from "../../shared/MaterialItemJson";
import PriceJson, { defaultPriceJson } from "../../shared/PriceJson";
import EventJson, {
  EventDescriptionAllowedTags,
  defaultEventJson,
  getEventJsonFromTemplateJson,
} from "../../shared/EventJson";
import { EventStatus, EventStatusNames } from "../../shared/EventStatus";
import EventImageJson, { defaultEventImageJson } from "../../shared/EventImageJson";
import EventDateJson, { defaultEventDateJson } from "../../shared/EventDateJson";
import EventTemplateJson from "../../shared/EventTemplateJson";
import { EventTemplateStatus } from "../../shared/EventTemplateStatus";
import ClientJson, { defaultClientJson } from "../../shared/ClientJson";
import ContactJson, { defaultContactJson } from "../../shared/ContactJson";

import Utils from "../../shared/Utils";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { validateEventJsonManagement } from "../../shared/EventJson";
import { validateEventJsonManagementAdd } from "../../shared/EventJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import PriceTemplates from "../custom/PriceTemplates";

type keysForCachedPrices = {
  [key in keyof Pick<
    PriceJson,
    | "priceDeposit"
    | "priceDepositAdditionalParticipant"
    | "priceNonDeposit"
    | "priceNonDepositAdditionalParticipant"
    | "cancellationFee"
  >]: string;
};

export default Vue.extend({
  name: "EventsEventDetails",
  components: {
    OverlayWindow,
    Loading,
    PointerMenu,
    CategoryTypeInput,
    CategoryTypeSelect,
    HtmlEditor,
    FormImageBase64,
    LocationInput,
    MaterialItemInput,
    ClientsClientSelect,
    StaffInput,
    FormPrice,
    CustomInputInput,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    eventId: Number,
    selectedEventDetails: Object,
    mode: String,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Utils: Utils,
      EventStatus: EventStatus,
      EventStatusNames: EventStatusNames,
      CategoryTypeType: CategoryTypeType,
      EventDescriptionAllowedTags: EventDescriptionAllowedTags,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      allEventTemplates: null as EventTemplateJson[] | null,
      eventTemplatesMoreAvailable: null as boolean | null,
      categoryTypes: null as CategoryTypeJson[] | null,
      selectedEventTemplate: null as EventTemplateJson | null,
      selectedTemplatePrices: {} as { [index: number]: any },
      cachedRegistrationBeginDateTime: "",
      cachedRegistrationEndDateTime: "",
      cachedDates: [] as {
        beginDateTime: string;
        endDateTime: string;
        beginTime: string;
        endTime: string;
      }[],
      cachedPrices: [] as keysForCachedPrices[],
      selectedDeletedPriceRestrictToTypes: [] as CategoryTypeJson[][],
      selectedEventId: null as number | null,
      eventDetails: null as EventJson | null,
      hasChanges: false,
      hintChanged: {
        program: false as boolean,
        staff: false as boolean,
        restrictStaff: false as boolean,
        estimatedChildrenCount: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<EventJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initEventDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
    this.setCachedData();
  },
  methods: {
    initEventDetails() {
      this.selectedEventId = this.eventId;

      this.loadEventTemplates();
      this.loadCategoryTypes();
      this.loadEventDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.setCachedDates();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadEventTemplates(loadMore: null = null) {
      if (loadMore == null) {
        this.allEventTemplates = null;
      }

      var states = [EventTemplateStatus.approved] as EventTemplateStatus[] | null;
      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.allEventTemplates != null) {
        this.eventTemplatesMoreAvailable = null;
        skipAmount = this.allEventTemplates.length;
      } else {
        this.allEventTemplates = null;
      }

      if (this.restClient != null) {
        try {
          let eventTemplates = await this.restClient.getEventTemplates(states, null, skipAmount);

          if (loadMore && this.allEventTemplates != null) {
            this.allEventTemplates = this.allEventTemplates.concat(eventTemplates.eventTemplates);
          } else {
            this.allEventTemplates = eventTemplates.eventTemplates;
          }

          this.eventTemplatesMoreAvailable = eventTemplates.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadCategoryTypes() {
      this.categoryTypes = null;

      try {
        this.categoryTypes = await this.restClient.getCategoryTypes();

        this.filterDeletedPriceRestrictToTypes();

        this.$nextTick(() => {
          this.hasChanges = false;
        });
      } catch (e) {
        alert(e.message);
      }
    },

    async loadEventDetails() {
      if (this.selectedEventId != null) {
        this.eventDetails = await this.restClient.getEvent(this.selectedEventId);
        //this.eventDetails = this.selectedEventDetails;
      } else {
        this.eventDetails = { ...defaultEventJson() };

        this.initRegistrationDateTimes();
        this.markPriceAsNew();
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    getDefaultPrice(): PriceJson {
      return { ...defaultPriceJson() };
    },

    selectEventTemplate() {
      if (this.selectedEventTemplate) {
        this.eventDetails = getEventJsonFromTemplateJson(this.selectedEventTemplate);
      }
    },

    //START set cached data

    setCachedDates() {
      if (this.eventDetails != null) {
        if (this.eventDetails["registrationBeginDateTime"] != "") {
          var d = new Date(this.eventDetails["registrationBeginDateTime"]);

          if (this.supportsDatePicker) {
            this.cachedRegistrationBeginDateTime = DateFormatter.formatISODate(d);
          } else {
            if (d != null) {
              this.cachedRegistrationBeginDateTime = DateFormatter.formatDateMedium(d);
            }
          }
        }

        if (this.eventDetails["registrationEndDateTime"] != "") {
          var d = new Date(this.eventDetails["registrationEndDateTime"]);

          if (this.supportsDatePicker) {
            this.cachedRegistrationEndDateTime = DateFormatter.formatISODate(d);
          } else {
            if (d != null) {
              this.cachedRegistrationEndDateTime = DateFormatter.formatDateMedium(d);
            }
          }
        }

        if (this.eventDetails.dates) {
          for (let i = 0; i < this.eventDetails.dates.length; i++) {
            this.cachedDates[i] = {
              beginDateTime: "",
              endDateTime: "",
              beginTime: "",
              endTime: "",
            };

            if (this.eventDetails.dates[i].beginDateTime != "") {
              var d = new Date(this.eventDetails.dates[i].beginDateTime);

              if (this.supportsDatePicker) {
                this.cachedDates[i].beginDateTime = DateFormatter.formatISODate(d);
              } else {
                if (d != null) {
                  this.cachedDates[i].beginDateTime = DateFormatter.formatDateMedium(d);
                }
              }

              this.cachedDates[i].beginTime = this.DateFormatter.formatTime(d);
            }

            if (this.eventDetails.dates[i].endDateTime != "") {
              var d = new Date(this.eventDetails.dates[i].endDateTime);

              if (this.supportsDatePicker) {
                this.cachedDates[i].endDateTime = DateFormatter.formatISODate(d);
              } else {
                if (d != null) {
                  this.cachedDates[i].endDateTime = DateFormatter.formatDateMedium(d);
                }
              }

              this.cachedDates[i].endTime = this.DateFormatter.formatTime(d);
            }
          }
        }
      }
    },

    //END set cached data

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Veranstaltung hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Veranstaltung bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Veranstaltung";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.hasChanges = false;
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.eventDetails != null) {
        this.validation = validateEventJsonManagement(this.eventDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    initRegistrationDateTimes() {
      if (this.eventDetails != null) {
        if (this.eventDetails.registrationBeginDateTime == "") {
          let beginDateTime: Date = new Date();
          beginDateTime.setHours(0, 0, 0);
          this.eventDetails.registrationBeginDateTime = DateFormatter.formatISODateTime(beginDateTime);
        }

        if (
          this.eventDetails.registrationEndDateTime == "" ||
          new Date(this.eventDetails.registrationBeginDateTime).getTime() >=
            new Date(this.eventDetails.registrationEndDateTime).getTime()
        ) {
          let beginDateTime: Date = new Date(this.eventDetails.registrationBeginDateTime);
          beginDateTime.setDate(beginDateTime.getDate() + 1);
          beginDateTime.setHours(23, 59);
          this.eventDetails.registrationEndDateTime = DateFormatter.formatISODateTime(beginDateTime);
        }

        this.setCachedDates();
      }
    },

    //prices

    addPrice() {
      if (this.eventDetails != null) {
        this.eventDetails.prices.push(this.getDefaultPrice());

        this.markPriceAsNew();
      }
    },

    deletePrice(index: number) {
      if (this.eventDetails != null && this.eventDetails.prices != null) {
        this.eventDetails.prices.splice(index, 1);
        this.cachedPrices.splice(index, 1);

        delete this.toValidate["prices-" + index];
      }
    },

    markPriceAsNew() {
      if (this.eventDetails != null) {
        let index = this.eventDetails.prices.length - 1;
        this.selectedTemplatePrices[index] = null;
      }
    },

    //START set input data (where data be cached)

    setRegistrationBeginDateTime() {
      if (this.eventDetails != null) {
        var date = "";

        if (this.supportsDatePicker) {
          date = DateFormatter.formatUSDate(new Date(this.cachedRegistrationBeginDateTime));
        } else {
          if (this.cachedRegistrationBeginDateTime.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedRegistrationBeginDateTime);

            if (d != null) {
              date = DateFormatter.formatUSDate(d);
            }
          }
        }

        if (isNaN(new Date(date).getTime())) {
          this.eventDetails.registrationBeginDateTime = "";
        } else {
          var dateTime = new Date(date);

          if (this.eventDetails.registrationBeginDateTime != "") {
            let time = DateFormatter.formatTime(new Date(this.eventDetails.registrationBeginDateTime));

            dateTime = new Date(date + " " + time);
          }

          this.eventDetails.registrationBeginDateTime = DateFormatter.formatISODateTime(dateTime);
        }
      }
    },

    setRegistrationEndDateTime() {
      if (this.eventDetails != null) {
        var date = "";

        if (this.supportsDatePicker) {
          date = DateFormatter.formatUSDate(new Date(this.cachedRegistrationEndDateTime));
        } else {
          if (this.cachedRegistrationEndDateTime.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedRegistrationEndDateTime);

            if (d != null) {
              date = DateFormatter.formatUSDate(d);
            }
          }
        }

        if (isNaN(new Date(date).getTime())) {
          this.eventDetails.registrationEndDateTime = "";
        } else {
          var dateTime = new Date(date);

          if (this.eventDetails.registrationEndDateTime != "") {
            let time = DateFormatter.formatTime(new Date(this.eventDetails.registrationEndDateTime));

            dateTime = new Date(date + " " + time);
          }

          this.eventDetails.registrationEndDateTime = DateFormatter.formatISODateTime(dateTime);
        }
      }
    },

    setDates(index: any) {
      if (index != null && this.eventDetails != null && this.eventDetails.dates != null) {
        let k = this.cachedDates[index];
        let i: keyof typeof k;

        for (i in k) {
          if (this.cachedDates[index].endDateTime == "") {
            this.cachedDates[index].endDateTime = this.cachedDates[index].beginDateTime;
          }

          var beginDate = "";
          var endDate = "";

          if (this.supportsDatePicker) {
            //beginDateTime
            beginDate = DateFormatter.formatUSDate(new Date(this.cachedDates[index].beginDateTime));

            //endDateTime
            endDate = DateFormatter.formatUSDate(new Date(this.cachedDates[index].endDateTime));
          } else {
            //beginDateTime
            if (this.cachedDates[index].beginDateTime.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(this.cachedDates[index].beginDateTime);

              if (d != null) {
                beginDate = DateFormatter.formatUSDate(d);
              }
            }

            //endDateTime
            if (this.cachedDates[index].endDateTime.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(this.cachedDates[index].endDateTime);

              if (d != null) {
                endDate = DateFormatter.formatUSDate(d);
              }
            }
          }

          //beginDateTime Time
          if (isNaN(new Date(beginDate).getTime())) {
            this.eventDetails.dates[index].beginDateTime = "";
          } else {
            let beginDateTime = new Date(beginDate);

            if (this.cachedDates[index].beginTime != "") {
              beginDateTime = new Date(beginDate + " " + this.cachedDates[index].beginTime);
            }

            this.eventDetails.dates[index].beginDateTime = DateFormatter.formatISODateTime(beginDateTime);

            this.cachedDates[index].beginTime = DateFormatter.formatTime(beginDateTime);
          }

          //endDateTime Time
          if (isNaN(new Date(endDate).getTime())) {
            this.eventDetails.dates[index].endDateTime = "";
          } else {
            let endDateTime = new Date(endDate);

            if (this.cachedDates[index].endTime != "") {
              endDateTime = new Date(endDate + " " + this.cachedDates[index].endTime);
            }

            this.eventDetails.dates[index].endDateTime = DateFormatter.formatISODateTime(endDateTime);

            this.cachedDates[index].endTime = DateFormatter.formatTime(endDateTime);
          }
        }
      }
    },

    formatDateTimes(index: any) {
      //begin
      let beginTime = this.cachedDates[index].beginTime.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

      if (beginTime.match(/^\d{2,2}:\d{2,2}$/g)) {
        this.cachedDates[index].beginTime = beginTime;
      }

      //end
      let endTime = this.cachedDates[index].endTime.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

      if (beginTime.match(/^\d{2,2}:\d{2,2}$/g)) {
        this.cachedDates[index].endTime = endTime;
      }
    },

    //END set input data (where data be cached)

    addImage() {
      if (this.eventDetails != null) {
        if (this.eventDetails.images.length < 5) {
          this.eventDetails.images.push({ ...defaultEventImageJson() });
        }
      }
    },

    deleteImage(index: number) {
      if (this.eventDetails != null) {
        this.eventDetails.images.splice(index, 1);

        delete this.toValidate["images-" + index];
      }
    },

    addDate() {
      if (this.eventDetails != null) {
        this.cachedDates.push({ beginDateTime: "", endDateTime: "", beginTime: "", endTime: "" });

        if (this.eventDetails.dates == null) this.eventDetails.dates = [];

        if (this.eventDetails.dates.length <= 0) {
          this.eventDetails.dates.push({ ...defaultEventDateJson() });
        } else {
          let lastItem = this.eventDetails.dates.length - 1;

          this.eventDetails.dates.push({
            ...defaultEventDateJson(),
            location: JSON.parse(JSON.stringify(this.eventDetails.dates[lastItem].location)),
            staffIds: JSON.parse(JSON.stringify(this.eventDetails.dates[lastItem].staffIds)),
            materialItems: JSON.parse(JSON.stringify(this.eventDetails.dates[lastItem].materialItems)),
          });
        }
      }
    },

    deleteDate(index: number) {
      if (this.eventDetails != null && this.eventDetails.dates != null) {
        this.eventDetails.dates.splice(index, 1);
        this.cachedDates.splice(index, 1);

        delete this.toValidate["dates-" + index];

        if (this.eventDetails.dates.length <= 0) this.eventDetails.dates = null;
      }
    },

    setResetDetailsForOfferBooking() {
      if (this.eventDetails != null) {
        this.eventDetails.registrationMaximumCount = 99999;
        this.eventDetails.waitingListMaximumCount = 0;
        this.eventDetails.restrictMinimumAge = null;
        this.eventDetails.restrictMaximumAge = null;
      }
    },

    async addNewEvent() {
      if (this.eventDetails != null) {
        this.loadingGeneral = true;

        if (this.eventDetails.dates == null) this.setResetDetailsForOfferBooking();

        this.validation = validateEventJsonManagementAdd(this.eventDetails);

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.eventDetails = await this.restClient.addEvent(this.eventDetails);
            alert("Die Veranstaltung wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Die Veranstaltung konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveEventDetails() {
      if (this.eventDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          if (this.eventDetails.dates == null) this.setResetDetailsForOfferBooking();

          this.submitValidation = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateEventJsonManagement(this.eventDetails);
          //todo ###END
          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedEventDetails = await this.restClient.updateEvent(this.eventDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteEvent() {
      if (this.selectedEventId != null) {
        let c = confirm("Wollen Sie diese Veranstaltung wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteEvent(this.selectedEventId);
              this.closeDetails();
              alert("Die Veranstaltung wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    filterDeletedPriceRestrictToTypes() {
      if (this.eventDetails != null) {
        var prices = this.eventDetails.prices;

        for (let i = 0; i < prices.length; i++) {
          var filteredDeletedRestrictToTypes: CategoryTypeJson[] = [];

          if (this.categoryTypes != null && prices[i].restrictToTypes != null) {
            filteredDeletedRestrictToTypes = prices[i].restrictToTypes!.filter(
              (pt: CategoryTypeJson) => !this.categoryTypes!.map((ct: CategoryTypeJson) => ct.ID).includes(pt.ID)
            );
          }

          this.selectedDeletedPriceRestrictToTypes[i] = [...filteredDeletedRestrictToTypes];
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    eventDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    baseUrl(): string {
      return window.location.protocol + "//" + window.location.hostname + "/";
    },

    parseRegistrationMaximumCount: {
      get(): number | undefined {
        if (this.eventDetails != null) {
          return this.eventDetails.registrationMaximumCount;
        }
      },
      set(value: string) {
        if (this.eventDetails != null) {
          this.eventDetails.registrationMaximumCount = parseInt(value);
        }
      },
    },

    parseWaitingListMaximumCount: {
      get(): number | undefined {
        if (this.eventDetails != null) {
          return this.eventDetails.waitingListMaximumCount;
        }
      },
      set(value: string) {
        if (this.eventDetails != null) {
          this.eventDetails.waitingListMaximumCount = parseInt(value);
        }
      },
    },

    parseRestrictMinimumAge: {
      get(): number | null | undefined {
        if (this.eventDetails != null) {
          return this.eventDetails.restrictMinimumAge;
        }
      },
      set(value: string) {
        if (this.eventDetails != null) {
          if (value == "") {
            this.eventDetails.restrictMinimumAge = null;
          } else {
            this.eventDetails.restrictMinimumAge = parseInt(value);
          }
        }
      },
    },

    parseRestrictMaximumAge: {
      get(): number | null | undefined {
        if (this.eventDetails != null) {
          return this.eventDetails.restrictMaximumAge;
        }
      },
      set(value: string) {
        if (this.eventDetails != null) {
          if (value == "") {
            this.eventDetails.restrictMaximumAge = null;
          } else {
            this.eventDetails.restrictMaximumAge = parseInt(value);
          }
        }
      },
    },

    selectedDeletedCategoryTypes(): CategoryTypeJson[] {
      let filteredRestrictToTypes: CategoryTypeJson[] = [];

      if (this.eventDetails?.restrictToTypes != null) {
        filteredRestrictToTypes = this.eventDetails.restrictToTypes;
        filteredRestrictToTypes = filteredRestrictToTypes.filter((i: CategoryTypeJson) => {
          if (this.categoryTypes != null) {
            if (!this.categoryTypes.includes(i)) {
              return i;
            }
          }
        });
      }

      return filteredRestrictToTypes;
    },

    formatRegistrationBeginTime: {
      get(): string | undefined {
        if (this.eventDetails != null) {
          let d = new Date(this.eventDetails.registrationBeginDateTime);
          let time = DateFormatter.formatTime(d);
          if (time == "unbekannt") {
            return "";
          } else {
            return DateFormatter.formatTime(d);
          }
        }
      },
      set(value: string) {
        let time = value.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

        if (this.eventDetails != null && time.match(/^\d{2,2}:\d{2,2}$/g)) {
          if (this.eventDetails.registrationBeginDateTime != "") {
            let date = DateFormatter.formatUSDate(new Date(this.eventDetails.registrationBeginDateTime));
            this.eventDetails.registrationBeginDateTime = DateFormatter.formatISODateTime(new Date(date + " " + time));
          }
        }
      },
    },

    formatRegistrationEndTime: {
      get(): string | undefined {
        if (this.eventDetails != null) {
          let d = new Date(this.eventDetails.registrationEndDateTime);
          let time = DateFormatter.formatTime(d);
          if (time == "unbekannt") {
            return "";
          } else {
            return time;
          }
        }
      },
      set(value: string) {
        let time = value.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

        if (this.eventDetails != null && time.match(/^\d{2,2}:\d{2,2}$/g)) {
          if (this.eventDetails.registrationEndDateTime != "") {
            let date = DateFormatter.formatUSDate(new Date(this.eventDetails.registrationEndDateTime));
            this.eventDetails.registrationEndDateTime = DateFormatter.formatISODateTime(new Date(date + " " + time));
          }
        }
      },
    },
  },
});
